import { render, staticRenderFns } from "./Stake.vue?vue&type=template&id=45d6796f&scoped=true&"
import script from "./Stake.vue?vue&type=script&lang=js&"
export * from "./Stake.vue?vue&type=script&lang=js&"
import style0 from "./Stake.vue?vue&type=style&index=0&id=45d6796f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6796f",
  null
  
)

export default component.exports